const server = 'https://apiv3.humoq.com';
module.exports = {
    server
}
